import './Novidades.css';
import { useTranslation } from 'react-i18next';

function NovidadesPopup({ onClose }) {
  const { t: tChat, i18n } = useTranslation('chat');

  // Mapeamento dos GIFs por idioma. Ajuste os nomes/paths conforme onde você salvou os arquivos.
  // Coloque os 3 arquivos em public/imagens ou importe diretamente se estiverem em src/assets.
  const gifPorIdioma = {
    pt: '/imagens/novidades_pt.gif',
    en: '/imagens/novidades_en.gif',
    fr: '/imagens/novidades_fr.gif'
  };

  // Normaliza idioma (ex: 'en-US' -> 'en') e define fallback.
  const lang = (i18n.language || 'pt').split('-')[0];
  const gifSrc = gifPorIdioma[lang] || gifPorIdioma.pt;

  return (
    <div className="novidades-overlay">
      <div className="novidades-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button-wrapper" onClick={onClose}>
          <img src="/imagens/x.svg" alt={tChat('closeIcon')} className="close-icon" />
        </button>

        {/* Espaço reservado para o GIF ou vídeo (mantido) */}
        <div className="gif-placeholder">
          <img src={gifSrc} alt={tChat('novidades.gifAlt')} />
        </div>

        <div className="novidade-text-wrapper">
            <h1 className="novidade-title">{tChat('novidades.title')}</h1>

            <div className="novidade-body-content">
                <p>
                    <strong dangerouslySetInnerHTML={{ __html: tChat('novidades.image_upload_title') }} />
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: tChat('novidades.image_upload_description') }} />
                </p>
                <p>

                    <strong dangerouslySetInnerHTML={{ __html: tChat('novidades.excel_read_title') }} />
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: tChat('novidades.excel_read_description') }} />
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: tChat('novidades.attention') }} />
                </p>
            </div>
        </div>

        <button className="testar-btn" onClick={onClose}>
          {tChat('novidades.test_button')}
        </button>

      </div>
    </div>
  );
}

export default NovidadesPopup;